<template>
	<div class="commitment-assignee-picker" @click="onClick">
		<div @click="onToggle" @touchstart.passive="onToggle">
			<UserAvatar
				v-if="assignedMember"
				class-name="commitment-assignee-picker__assigned-avatar"
				:user="assignedMember"
				size="1.375rem"
			/>
			<FontAwesomeIcon
				v-else
				class="commitment-assignee-picker__icon"
				:icon="['fas', 'user']"
			/>
		</div>
		<div :class="menuClasses">
			<CommitmentAssignees
				:members="members"
				:selected-member-id="selectedMemberId"
				@select="$emit( 'select', $event )"
			/>
		</div>
	</div>
</template>

<script>
import CommitmentAssignees from "./CommitmentAssignees.vue";
import UserAvatar from "../UserAvatar";

export default {
	name: "CommitmentAssigneePicker",
	emits: [ "toggle", "select", ],
	components: {
		CommitmentAssignees,
		UserAvatar,
	},
	props: {
		members: {
			type: Array,
			required: true,
		},
		selectedMemberId: {
			type: String,
			default: "",
		},
		isOpen: {
			type: Boolean,
			required: true,
		},
	},
	computed: {
		assignedMember() {
			const { selectedMemberId, members, } = this;
			if ( !selectedMemberId ) {
				return null;
			}
			return members.find( member => member.personId === selectedMemberId ) || null;
		},
		menuClasses() {
			return {
				"commitment-assignee-picker__menu": true,
				"commitment-assignee-picker__menu--open": this.isOpen,
			};
		},
	},
	methods: {
		onToggle( e ) {
			e.stopPropagation();
			e.preventDefault();
			this.$emit( "toggle" );
		},
		onClick( e ) {
			e.stopPropagation();
			e.preventDefault();
		},
	},
};
</script>

<style lang="scss" scoped>
.commitment-assignee-picker {
	border-radius: 50%;
	background: $commitment-assignee-picker-bg-color;
	color: $commitment-assignee-picker-font-color;
	height: 1.5rem;
	width: 1.5rem;
	display: flex;
	align-items: center;
	justify-content: flex-start;
	border: 0.0625rem solid $commitment-assignee-picker-border-color;
	box-shadow: 0 .0625rem .25rem rgba(42, 47, 69, 0.1);
	position: relative;
}

.commitment-assignee-picker__assigned-avatar {
	cursor: pointer;
	// size is set on the component itself
}

.commitment-assignee-picker__icon {
	cursor: pointer;
	width: 1.375rem;
}

.commitment-assignee-picker__menu {
	position: absolute;
	top: 100%;
	right: 0;
	z-index: 10;
	display:none;
}

.commitment-assignee-picker__menu--open {
	display:block;
}
</style>
